"use client";

import { LegalDocumentsPage } from "@/components/sections/LegalDocumentsPage";
import { privacyPolicyData } from "@/data/privacy-policy";

export default function PolitiqueConfidentialitePage() {
  return (
    <LegalDocumentsPage
      bannerTitle="Politique de confidentialité"
      eyebrow="Protection des données"
      intro="Vous trouverez ici les informations RGPD essentielles : données collectées, finalités, destinataires, durée de conservation et modalités d'exercice de vos droits."
      articles={privacyPolicyData}
    />
  );
}
